module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/plan_type_location_maedori@2x-cdd1f4a244581d76991a6ce277708840.webp";